import { createRouter, createWebHistory } from 'vue-router'
import WebCommonRouter from "@/router/h5/WebCommonRouter";
import WebAIRouter from "@/router/h5/WebAIRouter";
import WebLuQiaoRouter from "@/router/h5/WebLuQiaoRouter";
import WebCrmRouter from "@/router/h5/WebCrmRouter";
import QywxRouter from "@/router/qywx/QywxRouter";

let mainRouter;
let systemCode = process.env.VUE_APP_SYSTEM_CODE;
if (systemCode === "AI") {
    mainRouter = WebCommonRouter.concat(WebAIRouter);
} else if (systemCode === "LuQiao") {
    mainRouter = WebCommonRouter.concat(WebLuQiaoRouter);
} else if (systemCode === "CRM") {
    mainRouter = WebCommonRouter.concat(WebCrmRouter);
} else {
    mainRouter = WebCommonRouter;
}

// web端的路由
let webRouter = [
    {path: '/',redirect: '/welcome', meta: {title: "首页"}, component: () => import("@/views/h5/common/home/Home.vue"), children: mainRouter},
    // 打印设计
    {path: '/print/design/:templateKey?', meta: {title: "打印设计"}, component: () => import("@/views/h5/common/print/design/index.vue")},
    // 扫码查看单据：印在单据上的二维码指向这里，扫码的是第三方、没有账号，
    // 所以必须放在 Home 布局之外（Home 里的路由都要求登录）。
    {path: '/stock/order/view', meta: {title: "单据查看"}, component: () => import("@/views/h5/luqiao/stockOrder/view/OrderView.vue")}
] ;
if (systemCode === "LuQiao") { // 路桥，定制登录功能，登录跳转到首页
    webRouter.push({path: '/login/:type?', meta: {title: "登录"}, component: () => import("@/views/h5/luqiao/login/LuqiaoLogin.vue")});
    webRouter.push({path: '/monitor', meta: {title: "监控看板"}, component: () => import("@/views/h5/luqiao/monitor/Monitor.vue")},)
} else {
    webRouter.push({path: '/login/:type?', meta: {title: "登录"}, component: () => import("@/views/h5/common/login/Login.vue")});
}

let allRouter = webRouter.concat(QywxRouter);
// 所有路由中会有重复的，如果有重复的，就用新数据覆盖旧数据,方便业务系统对某个功能进行定制，不需要代码耦合，直接替换掉原有页面
function getUniqueRouter(routerList) {
    let arr = [];
    for (let i = 0; i < routerList.length; i++) {
        let item = routerList[i];
        // 如果有children
        if (item.children && item.children.length > 0) {
            item.children = getUniqueRouter(item.children);
        }
        let isExist = false;
        for (let j = 0; j < arr.length; j++) {
            if (arr[j].path === item.path) {
                arr[j] = item;
                isExist = true;
                break;
            }
        }
        if (!isExist) {
            arr.push(item);
        }
    }
    return arr;
}
let res = getUniqueRouter(allRouter);
const router = createRouter({
    mode: 'history',
    history: createWebHistory(),
    routes: res
})

export default router